/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_PriceInputs */

const en_mk_cmp_r_price = /** @type {(inputs: Mk_Cmp_R_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public pricing`)
};

const id_mk_cmp_r_price = /** @type {(inputs: Mk_Cmp_R_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga publik`)
};

/**
* | output |
* | --- |
* | "Public pricing" |
*
* @param {Mk_Cmp_R_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_price = /** @type {((inputs?: Mk_Cmp_R_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_price(inputs)
	return en_mk_cmp_r_price(inputs)
});